import { mapActions, mapState } from "vuex";

export const layoutComputed = {
  ...mapState("layout", {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader,
  }),
};

export const authMethods = mapActions("auth", [
  "logIn",
  "logOut",
  "register",
  "resetPassword",
]);

export const layoutMethods = mapActions("layout", [
  "changeLayoutType",
  "changeLayoutWidth",
  "changeLeftSidebarType",
  "changeTopbar",
  "changeLoaderValue",
]);

export const studentComputed = {
  ...mapState("students", { students: (state) => state.students }),
};
export const studentMethods = mapActions("students", [
  "filterStudents",
  "fetchStudents",
]);

export const userComputed = {
  ...mapState("users", { users: (state) => state.users }),
};
export const userMethods = mapActions("users", [
  "fetchUsers",
  "fetchCanteenUsers",
]);

export const parentComputed = {
  ...mapState("parents", { parents: (state) => state.parents }),
};
export const parentMethods = mapActions("parents", [
  "fetchParents",
  "filterParents",
]);

export const enrollmentComputed = {
  ...mapState("enrollments", { enrollments: (state) => state.enrollments }),
};
export const enrollmentMethods = mapActions("enrollments", [
  "fetchEnrollments",
  "filterEnrollments",
]);

export const countriesComputed = {
  ...mapState("countries", { countries: (state) => state.countries }),
};
export const countriesMethods = mapActions("countries", ["fetchCountries"]);

export const previousbalanceComputed = {
  ...mapState("previousbalances", {
    previousbalances: (state) => state.previousbalances,
  }),
};
export const previousbalanceMethods = mapActions("previousbalances", [
  "fetchPreviousBalances",
]);

export const expenseCategoryComputed = {
  ...mapState("expensecategories", {
    expensecategories: (state) => state.expensecategories,
  }),
};
export const expenseCategoryMethods = mapActions("expensecategories", [
  "fetchExpensecategories",
]);

export const expenseItemComputed = {
  ...mapState("expenseitems", { expenseitems: (state) => state.expenseitems }),
};
export const expenseItemMethods = mapActions("expenseitems", [
  "fetchExpenseitems",
]);

export const expenseComputed = {
  ...mapState("expenses", { expenses: (state) => state.expenses }),
};
export const expenseMethods = mapActions("expenses", ["fetchExpenses"]);

export const expensecartComputed = {
  ...mapState("expensecarts", { expensecarts: (state) => state.expensecarts }),
};
export const expensecartMethods = mapActions("expensecarts", [
  "fetchExpenseCart",
]);

export const paymentoptionComputed = {
  ...mapState("paymentoptions", {
    paymentoptions: (state) => state.paymentoptions,
  }),
};
export const paymentoptionMethods = mapActions("paymentoptions", [
  "fetchPaymentoptions",
]);

export const roleComputed = {
  ...mapState("roles", { roles: (state) => state.roles }),
};
export const roleMethods = mapActions("roles", ["fetchRoles"]);

export const auditComputed = {
  ...mapState("audits", { audits: (state) => state.audits }),
};
export const auditMethods = mapActions("audits", [
  "fetchAudits",
  "filterAudits",
]);

export const permissionComputed = {
  ...mapState("permissions", { permissions: (state) => state.permissions }),
};
export const permissionMethods = mapActions("permissions", [
  "fetchPermissions",
]);

export const feescategoryComputed = {
  ...mapState("feescategories", {
    feescategories: (state) => state.feescategories,
  }),
};
export const feescategoryMethods = mapActions("feescategories", [
  "fetchFeesCategories",
]);

export const feesbreakdownComputed = {
  ...mapState("feesbreakdowns", {
    feesbreakdowns: (state) => state.feesbreakdowns,
  }),
};
export const feesbreakdownMethods = mapActions("feesbreakdowns", [
  "fetchFeesBreakdowns",
]);

export const optionalfeeComputed = {
  ...mapState("optionalfees", { optionalfees: (state) => state.optionalfees }),
};
export const optionalfeeMethods = mapActions("optionalfees", [
  "fetchOptionalFees",
]);

export const optionalfeepaymentComputed = {
  ...mapState("optionalfeepayments", {
    optionalfeepayments: (state) => state.optionalfeepayments,
  }),
};
export const optionalfeepaymentMethods = mapActions("optionalfeepayments", [
  "fetchOptionalFeesPayments",
  "filterOptionalFeesPayments",
]);

export const busarieComputed = {
  ...mapState("busaries", { busaries: (state) => state.busaries }),
};
export const busarieMethods = mapActions("busaries", ["fetchBusaries"]);

export const studentBursarieComputed = {
  ...mapState("studentbursaries", {
    studentbursaries: (state) => state.studentbursaries,
  }),
};
export const studentBursarieMethods = mapActions("studentbursaries", [
  "fetchStudentBursaries",
]);

export const feesExemptionComputed = {
  ...mapState("feesexemptions", {
    feesexemptions: (state) => state.feesexemptions,
  }),
};
export const feesExemptionMethods = mapActions("feesexemptions", [
  "fetchFeesExemptions",
]);

export const feescartComputed = {
  ...mapState("feescarts", { feescarts: (state) => state.feescarts }),
};
export const feescartMethods = mapActions("feescarts", ["fetchFeesCart"]);

export const feespaymentComputed = {
  ...mapState("feespayments", { feespayments: (state) => state.feespayments }),
};
export const feespaymentMethods = mapActions("feespayments", [
  "fetchFeesPayments",
  "filterFeesPayments",
]);

export const studentpromoteComputed = {
  ...mapState("studentpromotes", {
    studentpromotes: (state) => state.studentpromotes,
  }),
};
export const studentpromoteMethods = mapActions("studentpromotes", [
  "fetchStudents",
  "addStudents",
]);

export const profileComputed = {
  ...mapState("profiles", { profiles: (state) => state.profiles }),
};
export const profileMethods = mapActions("profiles", ["fetchProfile"]);

export const schooltermComputed = {
  ...mapState("schoolterms", { schoolterms: (state) => state.schoolterms }),
};
export const schooltermMethods = mapActions("schoolterms", [
  "fetchSchoolTerms",
]);

export const schoolclassComputed = {
  ...mapState("schoolclasses", {
    schoolclasses: (state) => state.schoolclasses,
  }),
};
export const schoolclassMethods = mapActions("schoolclasses", [
  "fetchSchoolClasses",
]);

export const schoolstreamComputed = {
  ...mapState("schoolstreams", {
    schoolstreams: (state) => state.schoolstreams,
  }),
};
export const schoolstreamMethods = mapActions("schoolstreams", [
  "fetchSchoolStreams",
]);

export const schoolsubjectComputed = {
  ...mapState("schoolsubjects", {
    schoolsubjects: (state) => state.schoolsubjects,
  }),
};
export const schoolsubjectMethods = mapActions("schoolsubjects", [
  "fetchSchoolSubjects",
]);

export const schoolhouseComputed = {
  ...mapState("schoolhouses", { schoolhouses: (state) => state.schoolhouses }),
};
export const schoolhouseMethods = mapActions("schoolhouses", [
  "fetchSchoolHouses",
]);

export const examsetComputed = {
  ...mapState("examsets", { examsets: (state) => state.examsets }),
};
export const examsetMethods = mapActions("examsets", ["fetchExamSets"]);

export const examsettingComputed = {
  ...mapState("examsettings", { examsettings: (state) => state.examsettings }),
};
export const examsettingMethods = mapActions("examsettings", [
  "fetchExamSettings",
]);

export const gradingComputed = {
  ...mapState("gradings", { gradings: (state) => state.gradings }),
};
export const gradingMethods = mapActions("gradings", ["fetchGrading"]);

export const staffloadComputed = {
  ...mapState("staffloads", { staffloads: (state) => state.staffloads }),
};
export const staffloadMethods = mapActions("staffloads", ["fetchStaffLoads"]);

export const visitsComputed = {
  ...mapState("visits", { visits: (state) => state.visits }),
};
export const visitsMethods = mapActions("visits", [
  "fetchVisits",
  "filterVisits",
]);

export const booksComputed = {
  ...mapState("bookstore", { bookstore: (state) => state.bookstore }),
};
export const booksMethods = mapActions("bookstore", [
  "fetchBooks",
  "filterBooks",
]);

export const bookCategoriesComputed = {
  ...mapState("bookcategories", {
    bookcategories: (state) => state.bookcategories,
  }),
};
export const bookCategoriesMethods = mapActions("bookcategories", [
  "fetchBookcategories",
]);

export const libraryBooksComputed = {
  ...mapState("librarybooks", { librarybooks: (state) => state.librarybooks }),
};
export const libraryBooksMethods = mapActions("librarybooks", [
  "fetchLibraryBooks",
]);

export const booksBorrowedComputed = {
  ...mapState("booksborrowed", {
    booksborrowed: (state) => state.booksborrowed,
  }),
};
export const booksBorrowedMethods = mapActions(
  "booksborrowed",
  ["fetchBooksBorrowed"],
  "filterBooksBorrowed",
);

export const subjectdetailsComputed = {
  ...mapState("subjectdetails", {
    subjectdetails: (state) => state.subjectdetails,
  }),
};
export const subjectdetailsMethods = mapActions("subjectdetails", [
  "fetchSubjectDetails",
]);

export const nurserysubjectsComputed = {
  ...mapState("nurserysubjects", {
    nurserysubjects: (state) => state.nurserysubjects,
  }),
};
export const nurserysubjectsMethods = mapActions("nurserysubjects", [
  "fetchNurserySubjects",
]);

export const gradesComputed = {
  ...mapState("grades", { grades: (state) => state.grades }),
};
export const gradesMethods = mapActions("grades", ["fetchGrades"]);

export const subscriptionComputed = {
  ...mapState("subscriptions", {
    subscriptions: (state) => state.subscriptions,
  }),
};
export const subscriptionMethods = mapActions("subscriptions", [
  "fetchSubscriptions",
]);

export const schooleventComputed = {
  ...mapState("schoolevents", { schoolevents: (state) => state.schoolevents }),
};
export const schooleventMethods = mapActions("schoolevents", [
  "fetchSchoolEvents",
]);

export const moneytransferComputed = {
  ...mapState("moneytransfers", {
    moneytransfers: (state) => state.moneytransfers,
  }),
};
export const moneytransferMethods = mapActions("moneytransfers", [
  "fetchMoneyTransfers",
]);

export const chartsofaccountComputed = {
  ...mapState("chartsofaccounts", {
    chartsofaccounts: (state) => state.chartsofaccounts,
  }),
};
export const chartsofaccountMethods = mapActions("chartsofaccounts", [
  "fetchChartsOfAccounts",
]);

export const inventoryUnitComputed = {
  ...mapState("inventoryunits", {
    inventoryunits: (state) => state.inventoryunits,
  }),
};
export const inventoryUnitMethods = mapActions("inventoryunits", [
  "fetchInventoryunits",
]);

export const inventoryItemComputed = {
  ...mapState("inventoryitems", {
    inventoryitems: (state) => state.inventoryitems,
  }),
};
export const inventoryItemMethods = mapActions("inventoryitems", [
  "fetchInventoryitems",
]);

export const storeComputed = {
  ...mapState("stores", { stores: (state) => state.stores }),
};
export const storeMethods = mapActions("stores", ["fetchStores"]);

export const storecartComputed = {
  ...mapState("storecarts", { storecarts: (state) => state.storecarts }),
};
export const storecartMethods = mapActions("storecarts", ["fetchStoreCart"]);

export const storedetailComputed = {
  ...mapState("storedetails", { storedetails: (state) => state.storedetails }),
};
export const storedetailMethods = mapActions("storedetails", [
  "fetchStoredetails",
]);

export const requisitionComputed = {
  ...mapState("requisitions", { requisitions: (state) => state.requisitions }),
};
export const requisitionMethods = mapActions("requisitions", [
  "fetchRequitions",
]);

export const requisitioncartComputed = {
  ...mapState("requisitioncarts", {
    requisitioncarts: (state) => state.requisitioncarts,
  }),
};
export const requisitioncartMethods = mapActions("requisitioncarts", [
  "fetchRequisitionCart",
]);

export const requisitiondetailComputed = {
  ...mapState("requisitiondetails", {
    requisitiondetails: (state) => state.requisitiondetails,
  }),
};
export const requisitiondetailMethods = mapActions("requisitiondetails", [
  "fetchRequisitiondetails",
]);

export const requirementCategoryComputed = {
  ...mapState("requirementcategory", {
    requirementcategory: (state) => state.requirementcategory,
  }),
};
export const requirementCategoryMethods = mapActions("requirementcategory", [
  "fetchRequirementcategory",
]);

export const requirementallocationComputed = {
  ...mapState("requirementallocations", {
    requirementallocations: (state) => state.requirementallocations,
  }),
};
export const requirementallocationMethods = mapActions(
  "requirementallocations",
  ["fetchRequirementAllocations"],
);

export const schoolrequirementComputed = {
  ...mapState("schoolrequirements", {
    schoolrequirements: (state) => state.schoolrequirements,
  }),
};
export const schoolrequirementMethods = mapActions("schoolrequirements", [
  "fetchSchoolRequirement",
]);

export const requirementdetailComputed = {
  ...mapState("requirementdetails", {
    requirementdetails: (state) => state.requirementdetails,
  }),
};
export const requirementdetailMethods = mapActions("requirementdetails", [
  "fetchRequirementdetails",
  "filterCollection",
]);

export const setOptionalFeesComputed = {
  ...mapState("setoptionalfees", {
    setoptionalfees: (state) => state.setoptionalfees,
  }),
};
export const setOptionalFeesMethods = mapActions("setoptionalfees", [
  "fetchSetOptionalFees",
  "filterPayments",
]);

export const staffmemberComputed = {
  ...mapState("staffmembers", { staffmembers: (state) => state.staffmembers }),
};
export const staffmemberMethods = mapActions("staffmembers", [
  "fetchStaffMembers",
]);

export const positionComputed = {
  ...mapState("staffpositions", {
    staffpositions: (state) => state.staffpositions,
  }),
};
export const positionMethods = mapActions("staffpositions", [
  "fetchStaffPositions",
]);

export const staffleaveComputed = {
  ...mapState("staffleaves", { staffleaves: (state) => state.staffleaves }),
};
export const staffleaveMethods = mapActions("staffleaves", [
  "fetchStaffLeaves",
]);

export const staffadvanceComputed = {
  ...mapState("staffadvances", {
    staffadvances: (state) => state.staffadvances,
  }),
};
export const staffadvanceMethods = mapActions("staffadvances", [
  "fetchStaffAdvances",
]);

export const staffallowanceComputed = {
  ...mapState("staffallowances", {
    staffallowances: (state) => state.staffallowances,
  }),
};
export const staffallowanceMethods = mapActions("staffallowances", [
  "fetchStaffAllowances",
]);

export const salarypaymentComputed = {
  ...mapState("salarypayments", {
    salarypayments: (state) => state.salarypayments,
  }),
};
export const salarypaymentMethods = mapActions("salarypayments", [
  "fetchSalaryPayment",
  "filterSalaryPayment",
]);

export const staffdeductionComputed = {
  ...mapState("staffdeductions", {
    staffdeductions: (state) => state.staffdeductions,
  }),
};
export const staffdeductionMethods = mapActions("staffdeductions", [
  "fetchStaffDeductions",
]);

export const schooldepartmentComputed = {
  ...mapState("schooldepartments", {
    schooldepartments: (state) => state.schooldepartments,
  }),
};
export const schooldepartmentMethods = mapActions("schooldepartments", [
  "fetchSchoolDepartments",
]);

export const balancepaymentsComputed = {
  ...mapState("balancepayments", {
    balancepayments: (state) => state.balancepayments,
  }),
};
export const balancepaymentsMethods = mapActions("balancepayments", [
  "fetchBalancePayments",
]);

export const productsComputed = {
  ...mapState("products", { products: (state) => state.products }),
};
export const productsMethods = mapActions("products", [
  "fetchProducts",
  "filterProducts",
  "fetchCanteenProducts",
]);

export const savingsComputed = {
  ...mapState("savings", { savings: (state) => state.savings }),
};
export const savingsMethods = mapActions("savings", [
  "fetchSavings",
  "filterSavings",
]);

export const pocketmoneyComputed = {
  ...mapState("pocketmoney", { pocketmoney: (state) => state.pocketmoney }),
};
export const pocketmoneyMethods = mapActions("pocketmoney", [
  "fetchMoney",
  "filterPM",
]);

export const withdrawsComputed = {
  ...mapState("withdraws", { withdraws: (state) => state.withdraws }),
};
export const withdrawsMethods = mapActions("withdraws", [
  "fetchWithdraws",
  "filterWithdraws",
]);

export const studentattendanceComputed = {
  ...mapState("studentattendances", {
    studentattendances: (state) => state.studentattendances,
  }),
};
export const studentattendanceMethods = mapActions("studentattendances", [
  "fetchStudentattendances",
  "filterAttendance",
]);

export const staffattendancesComputed = {
  ...mapState("staffattendances", {
    staffattendances: (state) => state.staffattendances,
  }),
};
export const staffattendancesMethods = mapActions("staffattendances", [
  "fetchStaffattendances",
  "filterStaffAttendance",
]);

export const studentrollcallsComputed = {
  ...mapState("studentrollcalls", {
    studentrollcalls: (state) => state.studentrollcalls,
  }),
};
export const studentrollcallsMethods = mapActions("studentrollcalls", [
  "fetchStudentRollcalls",
  "filterStudentRollcall",
]);

export const salescartsComputed = {
  ...mapState("cartItems", { cartItems: (state) => state.cartItems }),
};
export const salescartsMethods = mapActions("cartItems", ["fetchSalesCarts"]);

export const canteensComputed = {
  ...mapState("canteens", { canteens: (state) => state.canteens }),
};
export const canteensMethods = mapActions("canteens", ["fetchCanteens"]);

export const homeworksComputed = {
  ...mapState("homeworks", { homeworks: (state) => state.homeworks }),
};
export const homeworksMethods = mapActions("homeworks", [
  "fetchHomeworks",
  "filterHomework",
]);

export const studymaterialsComputed = {
  ...mapState("studymaterials", {
    studymaterials: (state) => state.studymaterials,
  }),
};
export const studymaterialsMethods = mapActions("studymaterials", [
  "fetchStudyMaterials",
  "filterMaterial",
]);

export const commentgroupsComputed = {
  ...mapState("commentgroups", {
    commentgroups: (state) => state.commentgroups,
  }),
};
export const commentgroupsMethods = mapActions("commentgroups", [
  "fetchCommentGroups",
]);

export const commentsComputed = {
  ...mapState("nurserycomments", {
    nurserycomments: (state) => state.nurserycomments,
  }),
};
export const commentsMethods = mapActions("nurserycomments", ["fetchComments"]);

export const onlinepaymentsComputed = {
  ...mapState("onlinepayments", {
    onlinepayments: (state) => state.onlinepayments,
  }),
};
export const onlinepaymentsMethods = mapActions("onlinepayments", [
  "fetchOnlinePayments",
  "filterOnlinePayments",
]);
